<template>
<v-row justify="space-between" align="center" no-gutters>
  <v-col cols="6" sm="2">
    <div class="caption grey--text">{{coin}} price:</div>
    <span>{{getCoin(coin).price | price('USD', 2) }}</span>
    (<colored :value="getCoin(coin).percentChange24h / 100" :digits="2" format="percent" />)
  </v-col>
  <v-col cols="6" sm="3">
    <div class="caption grey--text">{{coin}} block reward per {{getCoin(coin).unit}}:</div>
    <div>{{getCoin(coin).miningEarning * getCoin(coin).price * getCoin(coin).unitFactor | price}} /{{getCoin(coin).unit}}/Day</div>
  </v-col>
  <v-col cols="6" sm="3" v-if="$vuetify.breakpoint.smAndUp">
    <div class="caption grey--text">{{coin}} block rewards (last 24 hr):</div>
    <div>{{getCoin(coin).totalReward24h * getCoin(coin).price | price('USD', 2)}}</div>
  </v-col>
  <v-col cols="6" sm="3" v-if="$vuetify.breakpoint.smAndUp">
    <div class="caption grey--text">{{coin}} hashrate(last 24h avg):</div>
    <div>{{getCoin(coin).hashrate | hashrate(coin)}}</div>
  </v-col>
  <v-col cols="3" sm="1" v-if="hideCoinToggle === undefined">
    <v-btn-toggle mandatory class="mr-4 pr-4">
      <v-btn small @click="$store.commit('product/setCurrency', 'USD')">USD</v-btn>
      <v-btn small @click="$store.commit('product/setCurrency', currency || 'COIN')">{{currency || coin}}</v-btn>
    </v-btn-toggle>
  </v-col>
</v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { price, unit, hashrate, totalReward } from "@/filters";
import Colored from "@/components/Colored";

export default {
  name: "CoinSummary",
  props: ["coin", "currency", "hideCoinToggle"],
  components: { Colored },
  filters: { price, unit, hashrate, totalReward },
  computed: {
    ...mapGetters("blockchain", ["getCoin"])
  }
}
</script>

<style scoped>
.v-item--active {
  color: #222;
  background-color: #ffe500 !important;
}
</style>